import { Container, Row, Col } from "react-bootstrap";

const anand =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/anand.webp";
const sahila =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/sahila.webp";
const rajaram =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/rajaram.webp";
const reema =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/Reema.png";
const vidhyaprabha =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/vidhya-prabha.webp";
const kalith =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/kalith.webp";
const praveen =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/Praveen.webp";
const sathya =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/Sathya.webp";
const prabhash =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/company/Prabhash.webp";

const OurTeamSection = () => {
  return (
    <section className="py-5" id="our-team">
      <Container className="mt-5">
        <h2 className="sub-heading text-center mb-4">Our Team</h2>
        <Row>
          <Col xs={12} lg={4}>
            <div className="team-img mb-2 mb-lg-5">
              <img src={anand} alt="Anand C" className="img-fluid w-100" />
            </div>
          </Col>
          <Col xs={12} lg={8}>
            <h2 className="sub-title mb-2">ANAND C</h2>
            <div className="position-text mb-2">CEO / Founder</div>
            <p>
              With a wealth of experience in the IT industry ranging from Tech
              Mahindra to SONY India, Anand is the founder and managing director
              of ACube. Under his leadership, the company has grown
              significantly over the last decade.
            </p>
            <p>
              A brilliant, sharp man who is gentle and soft-spoken, Anand loves
              spending his leisure time reading about photography and playing
              with his kids. A great fan of the outdoors, Anand is highly
              disciplined and takes great care of his health through rigorous
              diet and exercise.
            </p>
            <p>
              Anand has been awarded a B.E degree in Computer Science from MS
              University Tirunelveli and an M.B.A in International Business from
              the Annamalai University, Tamil Nadu.
            </p>
            <p>
              <a
                href="https://www.linkedin.com/in/anandonsite/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.linkedin.com/in/anandonsite
              </a>
            </p>
          </Col>
          <Col xs={12} lg={4}>
            <div className="team-img mb-2 mb-lg-5">
              <img src={sahila} alt="Sahila R" className="img-fluid w-100" />
            </div>
          </Col>
          <Col xs={12} lg={8}>
            <h2 className="sub-title mb-2">SAHILA R</h2>
            <div className="position-text mb-2">CFO / Director</div>
            <p>
              Sahila R is a director at Acube. She oversees all administrative,
              financial, and risk management operations of the company. Sahila
              also manages all ongoing developments and control systems designed
              to preserve company assets and report accurate financial results.
            </p>
          </Col>
          <Col xs={12} lg={4}>
            <div className="team-img mb-2 mb-lg-5">
              <img src={rajaram} alt="Rajaram G" className="img-fluid w-100" />
            </div>
          </Col>
          <Col xs={12} lg={8}>
            <h2 className="sub-title mb-2">RAJARAM G</h2>
            <div className="position-text mb-2">CTO</div>
            <p>
              Rajaram has 15 years of experience in Information Technology and
              primarily works in the Architecture and Technology domain for the
              last 7 years. He is a seasoned architect working in multiple
              architectural domains such as Enterprise Architecture, Solution
              Architecture, Technical Architecture, and Infrastructure
              Architecture.
            </p>
            <p>
              He has worked across different verticals and geographical
              locations, including working as an independent architect for key
              projects.
            </p>
            <p>
              He is an expert in defining IT Strategy, Enterprise Architecture,
              Transformation Solution, Application/ Technology Roadmap, and
              Solution Architecture.
            </p>
            <p>
              DevOps Specialist with a demonstrated working history in
              administering production systems, automating, and optimizing
              mission-critical deployments, leveraging configuration management,
              CI/CD, monitoring, and troubleshooting.
            </p>
            <p>
              He has proven experience in developing end-to-end Application
              Solutions in the field of Machine Learning and NLP, which helped
              clients and organizations benefit the most using relevant insights
              from data.
            </p>
            <p>
              <a
                href="https://www.linkedin.com/in/rajaramganjikunta/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.linkedin.com/in/rajaramganjikunta
              </a>
            </p>
          </Col>
          <Col xs={12} lg={4}>
            <div className="team-img mb-2 mb-lg-5">
              <img src={reema} alt="Reema Gonsalves" className="img-fluid w-100" />
            </div>
          </Col>
          <Col xs={12} lg={8}>
            <h2 className="sub-title mb-2">Reema Gonsalves</h2>
            <div className="position-text mb-2">HR Manager</div>
            <p>
              Reema is a dedicated Human Resources professional with 5 years of experience in the HR domain. She completed her Bachelor of Computer Applications (BCA), which provided her with a strong technical foundation and an analytical mindset that she continue to apply in her HR career. She began her career as a recruiter, where she developed a strong foundation in talent acquisition and candidate management. Over the years, her passion for people management and organizational development led her to grow into her current role as an HR professional within the company.
            </p>
            <p>
              Reema’s expertise includes end-to-end recruitment, employee onboarding, HR operations, employee engagement, performance support, and HR compliance. She is committed to creating a positive and productive work environment through strong employee and management relationships. With technical knowledge from her graduation and practical HR experience, she brings a balanced approach. She values continuous learning, clear communication, and process improvement. Reema consistently works to drive initiatives that enhance employee satisfaction and support organizational growth.
            </p>
          </Col>
          <Col xs={12} lg={4}>
            <div className="team-img mb-2 mb-lg-5">
              <img
                src={kalith}
                alt="Kalith Ahamed"
                className="img-fluid w-100"
              />
            </div>
          </Col>
          <Col xs={12} lg={8}>
            <h2 className="sub-title mb-2">KALITH AHAMED</h2>
            <div className="position-text mb-2">
              VP of Engineering / Delivery
            </div>
            <p>
              With over 12+ years of experience across various stages of the
              Software Development Life Cycle, he has strong hands-on experience
              in:
            </p>
            <p>- Web development using ASP.Net,</p>
            <p>- RESTful API Design &amp; Development,</p>
            <p>- Distributed SAAS Solutions design &amp; development,</p>
            <p>- Windows 8 LOB application development,</p>
            <p>- Kinect app development,</p>
            <p>- Native/Cross-Platform Mobile app design &amp; development</p>
            <p>- Adobe Flex development</p>
            <p>
              Kalith is an industry expert with a keen understanding of all
              aspects of Project/Client Requirements - with hands-on exposure in
              handling all phases of the Project/Program Life Cycle, right from
              requirement analysis, project scoping, implementation of robust
              technology solutions within the stipulated time, budget, and
              quality for our clients.
            </p>
            <p>
              He is an effective Team Leader who combines problem-solving skills
              with analytical, decision-making, and leadership capabilities to
              enhance Acube’s objectives.
            </p>
          </Col>
        </Row>
        <Row className="my-3">
          <Col xs={12}>
            <div className="d-flex align-items-center justify-content-around flex-wrap team-subsection">
              <div className="my-2 text-center">
                <div className="subteam-img">
                  <img src={prabhash} alt="Prabhash H" className="img-fluid" />
                </div>
                <p className="mt-2">PRABHASH H</p>
                <div className="position-text mb-2">Project Manager</div>
              </div>
              <div className="my-2 text-center">
                <div className="subteam-img">
                  <img
                    src={vidhyaprabha}
                    alt="Vidhya Prabha"
                    className="img-fluid"
                  />
                </div>
                <p className="mt-2">Vidhya Prabha</p>
                <div className="position-text mb-2">
                  Sr. Tech Lead/ Architect
                </div>
              </div>
              <div className="my-2 text-center">
                <div className="subteam-img">
                  <img src={sathya} alt="Sathya" className="img-fluid" />
                </div>
                <p className="mt-2">Sathya</p>
                <div className="position-text mb-2">
                  Sr. Tech Lead/ Architect
                </div>
              </div>
              <div className="my-2 text-center">
                <div className="subteam-img">
                  <img src={praveen} alt="Praveen" className="img-fluid" />
                </div>
                <p className="mt-2">Praveen</p>
                <div className="position-text mb-2">IT Admin</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section >
  );
};

export default OurTeamSection;
